module.exports = __webpack_public_path__ + "img/icon_password_eye_open.71334379.png";